import React from "react";
//#region types
import { SelectInputProps } from "models/propTypes/wintFormPropsTypes";
import { CustomerInfoStepProps } from "models/propTypes/customerImportPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { WizardSection, HorizontalFormField, SelectInput } from "components/common/wintForms";
//#endregion
import { CsvImportHelper, LocalizationHelperInstance } from "utils/helpers";

const CustomerInfoStep: React.FC<CustomerInfoStepProps> = ({ connect, submitted, wizardProps, headersObject }) => {
  const customerNameProps = connect("customerNameColumn");

  return (
    <WizardSection
      header={TranslationKeys.Common.General}
      hasErrors={customerNameProps.error}
      submitted={submitted}
      wizardProps={wizardProps}
    >
      <HorizontalFormField<SelectInputProps>
        Component={SelectInput}
        {...customerNameProps}
        controlLabel={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.Name)}
        label={CsvImportHelper.getColumnSelectFieldLabel(
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.Name)
        )}
        placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SelectColumn)}
        items={headersObject}
      />
      <HorizontalFormField<SelectInputProps>
        Component={SelectInput}
        {...connect("orgNrColumn")}
        controlLabel={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.OrgNr)}
        label={CsvImportHelper.getColumnSelectFieldLabel(
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.OrgNr)
        )}
        placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SelectColumn)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Customer.ImportOrgNrDescription
        )}
        items={headersObject}
        optional
      />
      <HorizontalFormField<SelectInputProps>
        Component={SelectInput}
        {...connect("emailAddressColumn")}
        controlLabel={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Email)}
        label={CsvImportHelper.getColumnSelectFieldLabel(
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Email)
        )}
        placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SelectColumn)}
        items={headersObject}
        optional
      />
      <HorizontalFormField<SelectInputProps>
        Component={SelectInput}
        {...connect("phoneNumberColumn")}
        controlLabel={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.ImportPhone)}
        label={CsvImportHelper.getColumnSelectFieldLabel(
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.ImportPhone)
        )}
        placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SelectColumn)}
        items={headersObject}
        optional
      />
    </WizardSection>
  );
};

export default CustomerInfoStep;
